import { render, staticRenderFns } from "./VillageVariation.vue?vue&type=template&id=0b732a53"
import script from "./VillageVariation.vue?vue&type=script&lang=js"
export * from "./VillageVariation.vue?vue&type=script&lang=js"
import style0 from "./VillageVariation.vue?vue&type=style&index=0&id=0b732a53&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports